class StickyCartBar {
  constructor() {
    this.bar = document.querySelector('#StickyCartBar');
    this.button = document.querySelector('#StickyCartButton');
    this.countElement = document.querySelector('#StickyCartCount');
    this.totalElement = document.querySelector('#StickyCartTotal');

    if (!this.bar || !this.button) return;

    this.handleCartUpdated = this.handleCartUpdated.bind(this);
    this.openCartDrawer = this.openCartDrawer.bind(this);

    this.button.addEventListener('click', this.openCartDrawer);

    document.addEventListener('cart:updated', this.handleCartUpdated);

    this.refresh();
  }

  async refresh() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept: 'application/json',
          },
          cache: 'no-store',
        }
      );

      if (!response.ok) return;

      const cart = await response.json();

      this.update(cart);
    } catch (error) {
      console.error('Sticky Cart:', error);
    }
  }

  handleCartUpdated(event) {
    const cart =
      event?.detail?.data ||
      event?.detail;

    if (cart && typeof cart.item_count !== 'undefined') {
      this.update(cart);
    } else {
      this.refresh();
    }
  }

  update(cart) {
    const count = Number(cart.item_count || 0);

    if (this.countElement) {
      this.countElement.textContent = count;
    }

    if (this.totalElement && typeof cart.total_price !== 'undefined') {
      this.totalElement.textContent = this.formatMoney(
        cart.total_price
      );
    }

    if (count > 0) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.bar.hidden = false;

    requestAnimationFrame(() => {
      this.bar.classList.add('is-visible');
    });
  }

  hide() {
    this.bar.classList.remove('is-visible');

    setTimeout(() => {
      if (!this.bar.classList.contains('is-visible')) {
        this.bar.hidden = true;
      }
    }, 250);
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      console.warn('Sticky Cart: cart-drawer element not found.');
      return;
    }

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open(this.button);
    }
  }

  formatMoney(cents) {
    const amount = Number(cents) / 100;

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(
        cents,
        window.theme?.moneyFormat || '{{amount}}'
      );
    }

    return amount.toFixed(2);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new StickyCartBar();
});